export enum BeaconAllColumns {
  title = "Title",
  status = "Status",
  startDate = "Start Date",
  endDate = "End Date",
  category = "Category",
  views = "Views", 
  action = "Action"
}

export enum BeaconModerationColumns {
  title = "Title",
  status = "Status",
  startDate = "Start Date",
  endDate = "End Date",
  category = "Category",
  action = "Action"
}

export const BeaconAllColumnKeys = Object.values(BeaconAllColumns);
export const BeaconModerationColumnKeys = Object.values(BeaconModerationColumns);

export interface BeaconColumnInfo {
  columnType: string;
  visibility: boolean;
}

export const BeaconListContexts = ["BEACONS", "MODERATION"] as const;
